import { chakra } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/contexts/i18n';
import { Alert } from 'toolkit/chakra/alert';

const DataFetchAlert = ({ className }: { className?: string }) => {
  const { t } = useI18n();

  return (
    <Alert status="warning" width="fit-content" className={ className }>
      { t('common.error.try_refresh') }
    </Alert>
  );
};

export default chakra(DataFetchAlert);
